export const actionTypes = {
  GET_EZD_PARAMETERS: "GET_EZD_PARAMETERS",
  SET_EZD_PARAMETERS: "SET_EZD_PARAMETERS",
  UPDATE_EZD_PARAMETERS: "UPDATE_EZD_PARAMETERS"
};

export const actions = {
  getEzdParameters: (payload) => ({
    type: actionTypes.GET_EZD_PARAMETERS,
    payload: payload,
  }),

  setEzdParameters: (payload) => ({
    type: actionTypes.SET_EZD_PARAMETERS,
    payload: payload,
  }),

  updateEzdParameter: (payload) => ({
    type: actionTypes.UPDATE_EZD_PARAMETERS,
    payload: payload,
  }),
};
